// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"f03dc22b","673":"06fe2d89","767":"9972eaac"}[chunkId] + ".chunk.js";
};